import React from "react";
import { Col, Form, Row } from "react-bootstrap";
import PropTypes from "prop-types";
import messages from "../views/Dashboard/Dashboard.messages";

// Components
import AlertDialog from "./AlertDialog";
import { injectIntl } from "react-intl";

const ReturnPaymentStep1 = (props) => {
    const lng = props.intl.formatMessage;

    /**
     * Handle changes in input fields and remove errors.
     *
     * @param e
     */
    const handleInputUpdate = (e) => {
        // remove validation errors
        if (e.target.checkValidity()) {
            e.target.classList.remove("is-invalid");
        }
        props.onFormChange(e);
    }
    
    return (
        <Row>
            <Col>
                <p className='text-dark'>{lng(messages.returnPaymentDescription)}</p>
                {props.error?.message && props.error.message !== '' && (
                    <AlertDialog
                        message={props.error.message}
                        type={props.error.type ?? 'light'}
                    />
                )}
                <Form id='returnpayment-dpid-form'>
                    <Form.Floating className='mb-3'>
                        <Form.Control
                            id='returnpayment-case-number'
                            name='caseNumber'
                            type='number'
                            placeholder={ lng(messages.caseNumber) }
                            autoComplete='off'
                            min='0'
                            max={Number.MAX_SAFE_INTEGER}
                            onChange={handleInputUpdate}
                            required
                            aria-required="true"
                            aria-label={lng(messages.caseNumber)}
                            value={props.form.caseNumber ?? ''}
                        />
                        <Form.Label htmlFor='returnpayment-case-number'>{ lng(messages.caseNumber) }</Form.Label>
                        <Form.Control.Feedback type="invalid" />
                    </Form.Floating>
                    <Form.Floating className='mb-3'>
                        <Form.Control
                            id='returnpayment-online-id'
                            name='onlineId'
                            type='text'
                            placeholder={ lng(messages.onlineId) }
                            autoComplete='off'
                            onChange={handleInputUpdate}
                            required
                            aria-required="true"
                            aria-label={lng(messages.onlineId)}
                            value={props.form.onlineId}
                        />
                        <Form.Label htmlFor="returnpayment-online-id">{ lng(messages.onlineId) }</Form.Label>
                        <Form.Control.Feedback type="invalid" />
                    </Form.Floating>
                </Form>
            </Col>
        </Row>
    );
};

ReturnPaymentStep1.propTypes = {
    intl: PropTypes.object.isRequired,
    error: PropTypes.object,
    form: PropTypes.object.isRequired,
    onFormChange: PropTypes.func.isRequired
};

export default injectIntl(ReturnPaymentStep1);
